<div class="flex-grow flex flex-col justify-between gap-4 relative">
  <div *ngIf="loading" class="absolute flex justify-center items-center h-full w-full bg-white">
    <app-loading-indicator [size]="32"></app-loading-indicator>
  </div>
  <div class="grid grid-cols-2 gap-4">
    <div class="flex flex-col">
      <label
        for="ballot-status"
        class="font-normal"
        id="ballot-status-label"
      >
        Ballot Status: &nbsp;&nbsp;
        <app-sd-ballot-status-badge
        id="ballot-status-value"
        [sdBallotStatus]="sdBallotStatus"
      ></app-sd-ballot-status-badge>
      </label>
      <label
        *ngIf="latestVoteDateWording"
        for="latest-vote-date"
        class="font-normal"
        id="ballot-result-label"
      >
        Results
        <span id="ballot-result-value" class="font-semibold">{{
          latestVoteDateWording
        }}</span>
      </label>
    </div>
    <div class="flex flex-col">
      <label class="font-normal" for="balloting-start-date" id="ballot-start-date-label">
        Balloting start date:
        <span id="ballot-start-date-value">
          {{ (projectDetails?.ballotStartDate | dateFormat) || NA }}
        </span>
      </label>
      <label class="font-normal" for="balloting-end-date" id="ballot-end-date-label">
        Balloting end date:
        <span id="ballot-end-date-value">
          {{ (projectDetails?.ballotEndDate | dateFormat) || NA }}
        </span>
      </label>
    </div>
  </div>

  <app-donut-chart
    id="ballot-pieChart"
    [data]="chartData"
    [showDecimalPlaces]="false"
    [showPercentage]="false"
  ></app-donut-chart>

  <div *ngIf="showConnectViewButton" class="flex flex-row">
    <a
      [id]="disableViewBallot ? 'a-view-in-ballot-disabled' : 'a-view-in-ballot'"
      class="btn"
      [ngClass]="{ 'btn-disabled': disableViewBallot, 'btn-primary': !disableViewBallot }"
      [routerLink]="['/ballots/npb', projectDetails?.sdBallotId]"
      [attr.aria-disabled]="disableViewBallot ? 'true' : null"
    >
      View Ballot
    </a>
  </div>
</div>
<div
  *ngIf="unableLoadingBallot || !authorized"
  class="flex-grow flex justify-center items-center"
>
  <p>Unable to load ballot details</p>
</div>

